import { useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Banner, ModalContext, Modals } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { isAuthenticatedSelector } from 'Store/modules/auth/selectors';
import { useTranslation } from 'Hooks/useTranslation';
import { useFetchGetUserClabe } from 'Containers/Account/components/AccountProfile/hooks';
import { useFetchGetCustomers } from 'Containers/Plans/hooks';
import DashboardClabeForm from 'Containers/Dashboard/components/TaxScreen/components/DashboardClabeForm';
import { setBodyOverflow } from 'Styles/utils/utils';
import { FRONT_PLANS, PLAN_FLEX_LITE, plansNameMapping } from 'Constants/plans';

const SaveClabeBanner = (): JSX.Element | null => {
  const isAuthenticated = useSelector(isAuthenticatedSelector);
  const { t } = useTranslation(locizeNS.DASHBOARD);
  const { showModal, hideModal } = useContext(ModalContext);
  const { isLoading, data } = useFetchGetUserClabe();
  const { data: customer } = useFetchGetCustomers(isAuthenticated);

  const plan = useMemo(
    () =>
      customer && customer.activePlan
        ? customer.activePlan.name === PLAN_FLEX_LITE
          ? FRONT_PLANS.FLEX_LITE
          : plansNameMapping(customer.activePlan.name)
        : FRONT_PLANS.BASIC,
    [customer]
  );

  const handleClick = (): void => {
    setBodyOverflow();
    showModal({
      comp: (
        <Modals.Centered maxSize="XL" hasClose onClose={hideModal}>
          <DashboardClabeForm />
        </Modals.Centered>
      ),
    });
  };

  const showClabeAccountBanner = !isLoading && !data?.CLABE && plan === FRONT_PLANS.FLEX;

  return showClabeAccountBanner ? (
    <Banner
      id="user_clabe_request"
      testID="clabeBanner"
      label={t(`User.Clabe.Title`)}
      description={t(`User.Clabe.Description`)}
      layout="embed"
      position="vertically"
      hasIcon
      buttonLabel={t(`User.Clabe.CTA`)}
      onClick={handleClick}
      mode="warning"
    />
  ) : null;
};

export default SaveClabeBanner;
